var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4115 10.7445C2.81615 10.513 2.51848 10.3972 2.43158 10.2304C2.35624 10.0858 2.35614 9.91354 2.4313 9.76886C2.51801 9.60195 2.81555 9.48584 3.41062 9.25361L20.2984 2.66327C20.8356 2.45364 21.1041 2.34883 21.2758 2.40616C21.4248 2.45596 21.5418 2.57292 21.5916 2.72197C21.6489 2.8936 21.5441 3.16219 21.3345 3.69937L14.7441 20.5871C14.5119 21.1822 14.3958 21.4797 14.2289 21.5664C14.0842 21.6416 13.9119 21.6415 13.7673 21.5662C13.6005 21.4793 13.4848 21.1816 13.2533 20.5862L10.6251 13.8282C10.5782 13.7074 10.5547 13.647 10.5184 13.5961C10.4862 13.551 10.4468 13.5115 10.4017 13.4794C10.3508 13.4431 10.2904 13.4196 10.1695 13.3726L3.4115 10.7445Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.e9a4400f87481ea2a0ac0277494807f8.svg";
export { ForwardRef as ReactComponent };